export default __webpack_public_path__ + "static/media/safetyNew.5502ba0b.jpeg";